import React from 'react';
import './Loader.css';
const Loader = (props) => {
    return ( <div className="loader">Loading...</div> );
}
 
export default Loader;